import React from 'react';
import { Phone, ArrowRight, CheckCircle2 } from 'lucide-react';
import { processSteps } from '../mockData';

export const ProcessSection = () => {
  return (
    <section className="py-16 lg:py-24 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-16">
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-gray-900 mb-4">
            How We Work
          </h2>
          <p className="text-lg text-gray-600 max-w-3xl mx-auto">
            Simple, efficient process to get you the products you need
          </p>
        </div>

        {/* Process Timeline */}
        <div className="relative">
          {/* Connection Line - Desktop */}
          <div className="hidden lg:block absolute top-1/2 left-0 right-0 h-1 bg-gradient-to-r from-blue-200 via-cyan-200 to-blue-200 -translate-y-1/2"></div>

          {/* Steps Grid */}
          <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-8 relative">
            {processSteps.map((step, index) => (
              <div key={step.id} className="relative">
                {/* Step Card */}
                <div className="bg-white rounded-xl p-6 shadow-lg border border-gray-200 hover:shadow-2xl transition-all duration-300 transform hover:-translate-y-2 relative z-10">
                  {/* Step Number */}
                  <div className="w-12 h-12 bg-gradient-to-br from-blue-900 to-blue-700 text-white rounded-full flex items-center justify-center text-xl font-bold mb-4 mx-auto shadow-lg">
                    {step.id}
                  </div>
                  
                  {/* Step Title */}
                  <h3 className="text-lg font-bold text-gray-900 mb-3 text-center">
                    {step.title}
                  </h3>
                  
                  {/* Step Description */}
                  <p className="text-gray-600 text-center">
                    {step.description}
                  </p>
                  
                  {/* Check Icon */}
                  <div className="flex justify-center mt-4">
                    <CheckCircle2 className="text-green-600" size={24} />
                  </div>
                </div>

                {/* Arrow - Desktop Only */}
                {index < processSteps.length - 1 && (
                  <div className="hidden lg:flex absolute top-1/2 -right-4 transform -translate-y-1/2 z-20">
                    <ArrowRight className="text-blue-400" size={32} />
                  </div>
                )}
              </div>
            ))}
          </div>
        </div>

        {/* CTA */}
        <div className="mt-16 text-center">
          <p className="text-lg text-gray-700 mb-6 font-medium">
            Ready to get started? Contact us today!
          </p>
          <a
            href="#contact"
            className="inline-flex items-center gap-2 bg-blue-900 text-white px-8 py-4 rounded-lg hover:bg-blue-800 transition-all duration-200 font-semibold text-lg shadow-lg hover:shadow-xl transform hover:-translate-y-0.5"
          >
            <Phone size={20} />
            Contact Us Now
          </a>
        </div>
      </div>
    </section>
  );
};
